import { useEffect, useState } from "react";
import ExportWorkQGroupWrapper from "./ExportWorkQGroupWrapper";
import CheckboxCell from "../../../common/interactive/CheckboxCell";
import { normalizeGroupedFields } from "../../../../lib/workQ";

export default function ExportWorkQGroupContainer({fields, classes, setFilters, filtersData}) {
    const [data, setData] = useState(null)
    const [selectAll, setSelectAll] = useState(data ? data.every(item => item.items.every(innerItem => innerItem.selected)) : true)

    function isFieldExportEnabled(item) {
        const hasExport = item?.export !== undefined && item?.export !== null
        const hasExportable = item?.exportable !== undefined && item?.exportable !== null

        // Backward-compatible default: include when no explicit export flags exist.
        if (!hasExport && !hasExportable) {
            return true
        }

        if (hasExport) {
            return item.export === 1 || item.export === true
        }

        return item.exportable === 1 || item.exportable === true
    }

    function makeFieldsObj(fields) {
        let data = []
        const normalized = normalizeGroupedFields(fields)
        if (normalized.length) {
            normalized.forEach(element => {
                let field = {
                    name: element.groupName,
                    items: element.items.filter(groupItem => isFieldExportEnabled(groupItem)).map(item => {
                        return {
                            name: item.name,
                            key: item.key,
                            selected : true
                        }
                    })
                }

                data.push(field)
            });
        }

        setData(data)
        if (setFilters) {
            setFilters(data)
        }
    }    

    useEffect(() => {
        makeFieldsObj(fields)
    }, [fields])

    function checkUncheckHandler(name, key, value) {
        let dataToUpdate = JSON.parse(JSON.stringify(data)) 

        const index = dataToUpdate.findIndex(object => {
            return object.name == name
        })

        if (index != -1) {
            const itemIndex = dataToUpdate[index].items.findIndex(object => {
                return object.key == key
            })

            if (itemIndex != -1) {
                dataToUpdate[index].items[itemIndex].selected = value
            }
        }

        setData(dataToUpdate)
        if (setFilters) {
            setFilters(dataToUpdate)
        }
    }

    function selectAllHandler(value) {
        setSelectAll(value.data.value)
        data.forEach(item => {
            item.items.forEach(item => {
                item.selected = value.data.value
            })
        })
        // setData(data)
        if (setFilters) {
            setFilters(data)
        }
    }

    let selectAllValue = data ? data.every(item => item.items.every(innerItem => innerItem.selected)) : true

    return <>
        <div className={classes.select_all_container}>
            <CheckboxCell checked={selectAllValue} label={selectAllValue ? 'Deselect All' : 'Select All'} direction={'reverse'} setStyle={'box_small'} action={selectAllHandler} identifier={{type: 'all'}}/>
        </div>
        {data && data.filter(item => item.items.length > 0).map(item => (
            <ExportWorkQGroupWrapper key={item.name} classes={classes} item={item} data={data} setData={setData} setFilters={setFilters} checkUncheckHandler={checkUncheckHandler} filtersData={filtersData}/>
        ))}
    </>
}